// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"354a10b3","453":"87ec0df3","455":"cbf422c0"}[chunkId] + ".chunk.js";
};